import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import ServiceCoverage from './pages/ServiceCoverage';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import FAQ from './pages/FAQ';
import CancellationPolicy from './pages/CancellationPolicy';
import RefundPolicy from './pages/RefundPolicy';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
export function App() {
  return <Router data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/service-coverage" element={<ServiceCoverage data-id="element-6" />} data-id="element-5" />
          <Route path="/about-us" element={<AboutUs data-id="element-8" />} data-id="element-7" />
          <Route path="/contact-us" element={<ContactUs data-id="element-10" />} data-id="element-9" />
          <Route path="/faq" element={<FAQ data-id="element-12" />} data-id="element-11" />
          <Route path="/cancellation-policy" element={<CancellationPolicy data-id="element-14" />} data-id="element-13" />
          <Route path="/refund-policy" element={<RefundPolicy data-id="element-16" />} data-id="element-15" />
          <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-18" />} data-id="element-17" />
          <Route path="/terms-conditions" element={<TermsConditions data-id="element-20" />} data-id="element-19" />
        </Routes>
      </Layout>
    </Router>;
}